export const setClickContext = (clickContext, e) => {
    e.nativeEvent.clickContext = clickContext;
};
export function getClickContext(e) {
    var _a;
    return (_a = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _a === void 0 ? void 0 : _a.clickContext;
}
//# sourceMappingURL=index.js.map